export default class {
	static async ajaxCall(url, type, data, isCsv = false) {
		let body;
		let error;
		const dataType = isCsv ? 'text' : 'json';
		const contentType = isCsv ? false : "application/json; charset=UTF-8";
		const processData = !isCsv;

		try {
			body = await $.ajax({
				url,
				type,
				data: data ? JSON.stringify(data) : null,
				dataType,
				contentType,
				processData,
				beforeSend: (xhr) => {
					if (type === 'post' || type === 'patch' || type === 'delete') {
						xhr.setRequestHeader('X-CSRFToken', $("[name=csrfmiddlewaretoken]").val());
					}
					if (!isCsv) {
						xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
					}
				}
			});
		} catch (e) {
			console.log(e);
			error = e;
		}

		return {
			body,
			error
		}
	}

	static listeners = {
		staffAdded: []
	};

	static on(event, callback) {
		if (this.listeners[event]) {
			this.listeners[event].push(callback);
		}
	}

	static emit(event, data) {
		if (this.listeners[event]) {
			this.listeners[event].forEach(cb => cb(data));
		}
	}

	static async getStaffByRoleJob(roleId, jobId, search = '') {
		let url = `/api/staff/?role_id=${roleId}&job_id=${jobId}`;

		if (search) {
			url += `&search=${search}`;
		}

		return await this.ajaxCall(url, 'get');
	}

	static async getStaffByName(search = '') {
		let url = `/api/staff/?search=${search}`;

		return await this.ajaxCall(url, 'get');
	}

	static async getStaffByPhoneNumber(phone_number = '') {
		let url = `/api/staff/?phone_number=${phone_number}`;

		return await this.ajaxCall(url, 'get');
	}

	static async getStaffByEmail(email = '') {
		let url = `/api/staff/?email=${email}`;

		return await this.ajaxCall(url, 'get');
	}


	static async addStaffToJob(staffId, roleId, jobId, canAddTallyData = false) {
		const url = `/api/jobs/${jobId}/add_staff/`;
		const data = {
			job_id: jobId,
			staff_id: staffId,
			role_id: roleId,
			can_add_tally_data: canAddTallyData
		};

		const result = await this.ajaxCall(url, 'post', data);

		if (!result.error) {
			const {body: {role_name: roleName, staff: {first_name, last_name}}} = result;

			const fullName = `${first_name} ${last_name}`;

			this.emit('staffAdded', {staffId, staffName: fullName, roleId, roleName});
		}

		return result;
	}

	static async addClientToJob(jobId, clientId) {
		const url = `/api/jobs/${jobId}/add_client/`;
		const data = {
			job_id: jobId,
			client_id: clientId
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async getFarmsForClient(clientId) {
		const url = `/api/clients/${clientId}/farms/`;
		return await this.ajaxCall(url, 'get');
	}

	static async addFarmToJob(jobId, farmId) {
		const url = `/api/jobs/${jobId}/add_farm/`;
		const data = {
			job_id: jobId,
			farm_id: farmId
		};

		return await this.ajaxCall(url, 'post', data);
	}

	// Farm CRUD operations
	static async createFarm(clientId, farmData) {
		const url = `/api/clients/${clientId}/farms/`;
		return await this.ajaxCall(url, 'post', farmData);
	}

	static async updateFarm(farmId, farmData) {
		const url = `/api/farms/${farmId}/`;
		return await this.ajaxCall(url, 'put', farmData);
	}

	static async deleteFarm(farmId) {
		const url = `/api/farms/${farmId}/`;
		return await this.ajaxCall(url, 'delete');
	}

	static async getFarm(farmId) {
		const url = `/api/farms/${farmId}/`;
		return await this.ajaxCall(url, 'get');
	}

	static async removeStaffFromJob(staffId, roleId, jobId) {
		const url = `/api/jobs/${jobId}/remove_staff/`;
		const data = {
			job_id: jobId,
			staff_id: staffId,
			role_id: roleId
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async sendJob(jobId) {
		const url = `/api/jobs/${jobId}/send_to_staff/`;
		const data = {
			job_id: jobId,
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async sendJobToClient(jobId) {
		const url = `/api/jobs/${jobId}/send_to_client/`;
		const data = {
			job_id: jobId,
		};

		return await this.ajaxCall(url, 'post', data);
	}

	// Backwards compatibility alias
	static async sendJobToFarm(jobId) {
		return await this.sendJobToClient(jobId);
	}

	static async getJobHistory(jobId) {
		const url = `/api/job-history/?job_id=${jobId}`;
		return await this.ajaxCall(url, 'get', '');
	}

	static async pauseResumeJob(jobId, action) {
		const url = `/api/jobs/${jobId}/pause_resume/`;
		const data = {
			action
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async sendMessage(jobId, message) {
		const url = `/api/jobs/${jobId}/send_message/`;

		const data = {
			message
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async sendTextMessage(sendTo, message) {
		const url = `/api/staff/send-text-message/`;

		const data = {
			send_to: sendTo,
			message
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async setStaffActiveStatus(staffId, isActive) {
		const url = `/api/staff/${staffId}/is-active/`;

		const data = {
			is_active: isActive
		};

		return await this.ajaxCall(url, 'patch', data);
	}

	static async toggleCanAddTallyData(staffWorkingJobId, canAddTallyData) {
		const url = `/api/jobs/toggle_can_add_tally_data/`;

		const data = {
			staff_working_job_id: staffWorkingJobId,
			can_add_tally_data: canAddTallyData
		};

		return await this.ajaxCall(url, 'post', data);
	}

	static async sendTallyAccessLink(staffWorkingJobId) {
		const url = `/api/jobs/send_tally_access_link/`;

		const data = {
			staff_working_job_id: staffWorkingJobId
		};

		return await this.ajaxCall(url, 'post', data);
	}
}

